import { ContainerCheck } from 'components/InputsMex/extras';
import React from 'react';

const CheckPagoOk = () => {
  return (
    <ContainerCheck className="d-inline" hideCursor width={100}>
      <input id="finish" type="checkbox" defaultChecked disabled />
      <label htmlFor="finish" />
    </ContainerCheck>
  );
};

export default CheckPagoOk;
